import _ from "lodash";
import moment from "moment-timezone";

export type DisplayRangeType = "day" | "week" | "month";

/**
 * Helper to determine the display range based on the range in list of objects with date property
 * @param list list can be an array of objects with any data, as long as date property exists
 * @returns
 */
const getDisplayRange = (list: Array<{date: Date}>): DisplayRangeType => {
  if (!list.length) {
    // return default view
    return "day";
  }

  const firstDate = _.minBy(list, "date")?.date;
  const lastDate = _.maxBy(list, "date")?.date;
  const range = moment(lastDate).diff(moment(firstDate), "days");
  let displayRange: DisplayRangeType = "day";

  // between 2 weeks and 2 months, display range is weeks
  if (range <= 60 && range >= 14) {
    displayRange = "week";
  } else if (range >= 61) {
    displayRange = "month";
  }

  return displayRange;
};

export default getDisplayRange;